import { render } from "./NavBar.vue?vue&type=template&id=5cb91dfc&scoped=true"
import script from "./NavBar.vue?vue&type=script&lang=js"
export * from "./NavBar.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-5cb91dfc"

export default script